import { render, staticRenderFns } from "./LocationNew.vue?vue&type=template&id=2c460a2b&"
import script from "./LocationNew.vue?vue&type=script&lang=js&"
export * from "./LocationNew.vue?vue&type=script&lang=js&"
import style0 from "./LocationNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports